import {
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableHeader,
    DataTableHeaderRow,
    EmptyState,
} from '@/components/system';
import PatientTestsRow from './PatientTestsRow';
import type { PatientTestOverview } from '@/types/patient-overview';
import type { ReactNode } from 'react';

type Props = {
    patientId: string;
    tests: PatientTestOverview[];
    onViewAnswers: (payload: { assignmentId: string; testName: string }) => void;
    emptyAction?: ReactNode;
};

export default function PatientTestsTable({ patientId, tests, onViewAnswers, emptyAction }: Props) {
    if (tests.length === 0) {
        return <EmptyState title="Nenhum instrumento enviado" action={emptyAction} />;
    }

    return (
        <DataTable>
            <DataTableHeader>
                <DataTableHeaderRow>
                    <DataTableHead>Instrumento</DataTableHead>
                    <DataTableHead>Status</DataTableHead>
                    <DataTableHead>Enviado em</DataTableHead>
                    <DataTableHead>Respondido em</DataTableHead>
                    <DataTableHead>Ações</DataTableHead>
                </DataTableHeaderRow>
            </DataTableHeader>
            <DataTableBody>
                {tests.map((test) => (
                    <PatientTestsRow
                        key={test.id}
                        patientId={patientId}
                        test={test}
                        onViewAnswers={onViewAnswers}
                    />
                ))}
            </DataTableBody>
        </DataTable>
    );
}
